<template>
<section class="stories-map relative">
    <div class="map" :id="block_id"></div>
    <div class="map-filters py-2 bg-white mx-auto w-full">
        <div class="flex text-center">
            <div class="w-1/3">
                <button @click="populate('all')" :disabled="currentFilter == 'all'" :class="{active: currentFilter == 'all'}" class="text-primary-600 p-4 hover:text-secondary-600 focus:text-secondary-600 mx-auto rounded">
                    <div class="flex items-center justify-center">
                        <i class="fa-solid fa-location-dot text-2xl mr-2" aria-hidden="true"></i>
                        <span class="font-headline font-bold uppercase">All</span>
                    </div>
                </button>
            </div>
            <div class="w-1/3">
                <button @click="populate('blurb')" :disabled="currentFilter == 'blurb'" :class="{active: currentFilter == 'blurb'}" class="text-primary-600 p-4 hover:text-secondary-600 focus:text-secondary-600 mx-auto rounded">
                    <div class="flex items-center justify-center">
                        <i class="fa-solid fa-pencil text-2xl mr-2" aria-hidden="true"></i>
                        <span class="font-headline font-bold uppercase">Story</span>
                    </div>
                </button>
            </div>
            <div class="w-1/3">
                <button @click="populate('video')" :disabled="currentFilter == 'video'" :class="{active: currentFilter == 'video'}" class="text-primary-600 p-4 hover:text-secondary-600 focus:text-secondary-600 mx-auto rounded">
                    <div class="flex items-center justify-center">
                        <i class="fa-solid fa-play text-2xl mr-2" aria-hidden="true"></i>
                        <span class="font-headline font-bold uppercase">Video</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { onMounted, ref } from 'vue';

const getStories = async () => {
    let req = new Request('/stories-json');
    let res = await fetch(req);
    res = await res.json();
    return res;
};

const geojsonEncode = (stories) => {

    let features = stories.map(story => {
        return {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [story.location.lng, story.location.lat]
            },
            properties: {
                title: story.title,
                description: story.blurb,
                type: story.type,
                link: story.link,
                includeLink: story.include_link,
            }
        }
    });

    return {
        type: 'FeatureCollection',
        features: features
    };

};

export default {

    props: ['data'],
    
    setup(props) {

        const stories = ref([]);
        const map = ref(null);
        const markers = ref([]);
        const currentFilter = ref('all');

        const resetMarkers = () => {
            for (let i = 0; i < markers.value.length; i++) {
                markers.value[i].remove();
            }
            markers.value = [];
        };

        const initialize = () => {
            mapboxgl.accessToken = props.data.mapbox_token;
            map.value = new mapboxgl.Map({
                container: props.data.block_id,
                style: 'mapbox://styles/waterforarizona/cl2z2ercl000l14qc969rt4tw',
                center: [-111.587658, 34.445522],
                zoom: 6
            });
        }

        const populate = async (filterBy) => {

            resetMarkers();

            let raw = await getStories();
            stories.value = geojsonEncode(raw);

            for (const feature of stories.value.features) {

                if (filterBy != 'all' && feature.properties.type != filterBy) {
                    continue;
                }

                // create a HTML element for each feature
                const el = document.createElement('div');
                el.className = `marker marker-${feature.properties.type}`;

                const popupOptions = {
                    offset: 25,
                    className: 'popup-' + feature.properties.type
                };

                const popupHtml = `<h3>${feature.properties.title}</h3>
                                <div class="blurb">${feature.properties.description}</div>`;

                if (feature.properties.includeLink) {
                    popupHtml = popupHtml + `<div class="read-more"><a href="${feature.properties.link}">Read More...</a></div>`;
                }

                let marker = new mapboxgl.Marker(el)
                    .setLngLat(feature.geometry.coordinates)
                    .setPopup(
                        new mapboxgl.Popup(popupOptions) // add popups
                            .setHTML(popupHtml)
                    );

                markers.value.push(marker);
                marker.addTo(map.value);

            }

            currentFilter.value = filterBy;

        };

        onMounted(() => {
            initialize();
            populate('all');
        });

        return {
            currentFilter,
            populate,
            ...props.data
        }
    }

}
</script>